import React, { createContext, useState, useContext, useEffect } from "react";
import { login, register, getCurrentUser } from "../api/auth"; // Removed logout
import { setAuthToken, removeAuthToken, getAuthToken } from "../api/client";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = getAuthToken();
    if (token) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchUser = async () => {
    try {
      const userData = await getCurrentUser();
      setUser(userData);
    } catch (err) {
      console.error("Auth error:", err);
      removeAuthToken();
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async (email, password) => {
    try {
      setError(null);
      const data = await login(email, password);
      setAuthToken(data.access_token);
      setUser(data.user);
      return { success: true };
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
      return { success: false, error: err.response?.data?.detail };
    }
  };

  const handleRegister = async (userData) => {
    try {
      setError(null);
      const data = await register(userData);
      setAuthToken(data.access_token);
      setUser(data.user);
      return { success: true };
    } catch (err) {
      setError(err.response?.data?.detail || "Registration failed");
      return { success: false, error: err.response?.data?.detail };
    }
  };

  const handleLogout = () => {
    removeAuthToken();
    setUser(null);
  };

  const value = {
    user,
    setUser,
    loading,
    error,
    login: handleLogin,
    register: handleRegister,
    logout: handleLogout,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
}
